@if(isLoading()){
<div class="mc-mt-100 mc-mt-md-0">
    <mi-approval-type-method-skeleton></mi-approval-type-method-skeleton>
</div>
}
@if(!isLoading()){
<div class="mi-approval-type-method-page  mc-mt-100 mc-mt-md-0" id="mi-approval-type-method-page" tabindex="-1"
    miFocusOnTab>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 mi-panel-wrraper">
                <section class="mi-panel-content">
                    <div class="mi-approval-type-method-wrapper col-12 mi-white-panel with-shadow "
                        id="mi-approval-type-method-wrapper">

                        <div class="mi-back ">
                            <mc-button [label]="genericText()?.back" [ariaLabel]="genericText()?.back"
                                [icon]="'pi pi-fw pi-chevron-right'" class="mi-button-with-icon-primary"
                                id="mi-approval-type-method-back" (click)="back()" (keyup.enter)="back()"></mc-button>
                        </div>
                        @if(haseMoreThanOneApprovalType()){
                        <h2 class="mi-approval-type-method-title mc-my-16">
                            {{approvalTypeMethodText()?.selectApprovalType}}
                        </h2>
                        <mc-form-field-wrapper class="col-xs-12 col-md-12 " [hideLable]="true"
                            [label]="chooseApprovalTypeLable" [customErrorMessages]="customErrorMessages"
                            [fieldId]="'mi-approvalType-id'">

                            <mc-radio-button-group [name]="'mi-approvalType-id'" (onChange)="approvalTypeChange($event)"
                                [options]="approvalTypes" [(ngModel)]="approvalType" [direction]="'column'"
                                [isRadioBool]="false" [disabled]="!isNewRequest" mc-accessibilityLabel>
                            </mc-radio-button-group>
                        </mc-form-field-wrapper>
                        }
                        @else{
                        <h2 class="mi-approval-type-method-title mc-my-16">
                            {{approvalTypeMethodText()?.selectApprovalTypeOneAptype}}
                        </h2>

                        <p>{{approvalTypes[0]?.label}}</p>
                        }

                        @if(showApprovalTypeInfo()){
                        <div class="mc-mt-64">
                            <mc-info level="info">
                                <span>{{approvalTypeInfo}}</span>
                            </mc-info>
                        </div>
                        }

                    </div>

                    <mi-selected-approval-type class="justify-content-center"
                        [approvalTypeName]="getApprovalTypeSelectedName()"
                        [approvalMainTypeName]="approvalMainTypeName"></mi-selected-approval-type>
                </section>
                <section
                    class="row justify-content-center   mi-approval-type-method-navigation justify-content-md-start"
                    id="mi-approval-type-method-navigation">
                    <div class=" mi-next blue-button col-md-3 col-12">
                        <mc-button [label]="genericText()?.next + ' >'" [ariaLabel]="genericText()?.next" (click)="next()"
                            [id]="'mi-approval-type-method-navigation-next'">

                        </mc-button>
                    </div>

                </section>
            </div>
        </div>

    </div>
</div>
}

<mc-dialog [dialogProperties]="dialogProperties">
    <div class="d-flex flex-column mi-approval-type-methods-dialog">
        <h2>
            {{approvalTypeMethodText()?.dialogApprovalChanged?.textPart1}}
        </h2>
        <span>
            {{approvalTypeMethodText()?.dialogApprovalChanged?.textPart2}}</span>

    </div>
</mc-dialog>